import React from 'react';
import './RoundedPanel.css';
import { ErrorBoundary } from 'Components/ErrorBoundary/ErrorBoundary';

export default function RoundedPanel({ children, style, noPanel }) {
  if (noPanel) {
    return <ErrorBoundary name="rounded panel">{children}</ErrorBoundary>;
  }

  return (
    <ErrorBoundary name="rounded panel">
      <div className="mainPanelBorder">
        <div className="mainPanelCanvas" style={style}>
          {children}
        </div>
      </div>
    </ErrorBoundary>
  );
}
